import Immutable from 'immutable';


export const State = Immutable.fromJS({
	isLoggedIn: false,
	isCompleted: false,
	currentStep: 0,
	
	// step 1
	buyProducts: {},
	buyRedeems: {},
	products: {},
	canShippingSelf: true,
	canShippingDelivery: true,
	canShippingTC: true,
	shippingSelfDateList: [],
	shippingDeliveryDateList: [],
	shippingTCDateList: [],
	// step 2
	storeIdNames: {},
	deliveryMethod: '1',
	deliveryDate: '',
	deliveryTime: '0',
	storeId: '1',

	purchaserName: '',
	purchaserGender: 'male',
	purchaserEmail: '',
	purchaserPhone: '',
	purchaserAddress: '',
	purchaserCity: '台北市',
	// purchaserName: 'Janie',
	// purchaserGender: 'female',
	// purchaserEmail: 'jchen@stormed.com',
	// purchaserPhone: '0912345678',
	// purchaserAddress: '台中市太平區',

	asPurchaserData: false,
	deliveryName: '', 
	deliveryGender: 'male', 
	deliveryPhone: '', 
	deliveryAddress: '',
	deliveryCity: '台北市',
	// deliveryName: 'RICH', 
	// deliveryGender: 'male', 
	// deliveryPhone: '0987654321', 
	// deliveryAddress: '台北市北投區',

	paymentMethod: '1',

	tcatCity: '',
	tcatStation: '',

	couponCode: '', 
	couponId: 0,
	couponContent: '', 
	minAmt: 0,
	couponDiscount: 0,
	promotionDiscount: 0,
	deduction: 100,
	freeShipping: false,
	gift: {},
	giftId: 0,

	invoiceType: '1',
	invoiceUbn: '',
	invoiceTitle: '',

	greetings: '', 
	note: '',

	islands: false,

	errorMessage: '',
	isAgreeTerms: false,
	shippingCost: 0,
	balanceDue: 0,
	orderId: '',

	useRedeem: null,
	newRedeem: null,

	TaiwanCity: {},
	TCatStations: {},
});